import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { trackCheckoutStart } from '../lib/metaPixel';

/** The single checkout every purchase button leads to. */
export const CHECKOUT_URL = 'https://makeup-instructor-readyfr.impultienda.ar/checkout';
export const CURRENCY_NOTE = 'Le paiement sera traité dans votre devise locale';

/** Anchor of the offer block. */
export const OFFER_ANCHOR = '#offer-cta';
type CtaAction = 'checkout' | 'offer';
interface CtaButtonProps {
  label: string;
  /** 'checkout' opens the checkout; 'offer' scrolls to the offer block. */
  action?: CtaAction;
  className?: string;
}
export function CtaButton({
  label,
  action = 'offer',
  className = ''
}: CtaButtonProps) {
  const isCheckout = action === 'checkout';
  return <a href={isCheckout ? CHECKOUT_URL : OFFER_ANCHOR} onClick={isCheckout ? trackCheckoutStart : undefined} className={`group inline-flex items-center justify-center gap-2.5 text-balance rounded-[16px] bg-brand-cta px-4 py-[22px] text-center font-body text-[14px] font-extrabold uppercase tracking-[0.02em] text-brand-cta-text shadow-[0_6px_0_0_#0A6B34,0_22px_40px_-12px_rgba(19,161,80,0.65)] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-brand-cta-dark active:translate-y-[4px] active:shadow-[0_2px_0_0_#0A6B34] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-cta focus-visible:ring-offset-2 sm:px-10 sm:py-6 sm:text-[17px] sm:tracking-[0.05em] ${className}`} data-id="element-1" data-mp="vc265d2t93ig">
      <span data-id="element-2" data-mp="3sxdewraqfhme">{label}</span>
      <span aria-hidden="true" className="hidden text-base font-normal transition-transform duration-200 ease-out group-hover:translate-x-1 sm:inline" data-id="element-3" data-mp="3swk8jrfoqu4s">
        →
      </span>
    </a>;
}
interface CtaBlockProps {
  label: string;
  action?: CtaAction;
  /** Small reassurance line under the button. */
  note?: string;
  /** 'light' for use on dark backgrounds. */
  tone?: 'dark' | 'light';
  className?: string;
}

/** Centered CTA block with the local-currency note above the button. */
export function CtaBlock({
  label,
  action = 'offer',
  note,
  tone = 'dark',
  className = ''
}: CtaBlockProps) {
  const muted = tone === 'light' ? 'text-white/65' : 'text-brand-charcoal/55';
  const currencyClass = tone === 'light' ? 'border-white/25 bg-white/10 text-white' : 'border-brand-plum/20 bg-brand-lavender text-brand-plum-dark';
  return <div className={`flex flex-col items-center text-center ${className}`} data-id="element-4" data-mp="9ias3fc228tr">
      <p className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 font-body text-[13px] font-bold leading-snug sm:text-[14px] ${currencyClass}`} data-id="element-5" data-mp="9kdt0ueqxmd9">
        <GlobeIcon className="h-4 w-4 flex-none" strokeWidth={2.25} aria-hidden="true" data-id="element-6" data-mp="jfyxcz7aeyq6" />
        {CURRENCY_NOTE}
      </p>
      <CtaButton label={label} action={action} className="mt-4 w-full sm:w-auto sm:min-w-[460px]" data-id="element-7" data-mp="eft4jfpa766i" />
      {note && <p className={`mt-4 font-body text-[12px] uppercase tracking-[0.12em] ${muted}`} data-id="element-8" data-mp="2g90iolt5rhqt">{note}</p>}
    </div>;
}